import { parseSkillMd } from "./spec";

export type Skill = {
  name: string;
  description: string;
  reference: string;
};

export function parseSkill(raw: string): Skill {
  const parsed = parseSkillMd(raw);
  return {
    name: parsed.manifest.name,
    description: parsed.manifest.description,
    reference: parsed.instructions,
  };
}

export function parseSkills(skillFiles: Record<string, string>): Skill[] {
  return Object.entries(skillFiles)
    .filter(([path]) => /^[^/]+\/SKILL\.md$/.test(path))
    .map(([path, content]) => {
      const skill = parseSkill(content);
      if (path !== `${skill.name}/SKILL.md`) {
        throw new Error(`Built-in skill name does not match its path: ${path}`);
      }
      return skill;
    });
}
